/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import { components } from '@glowingblue-orell-thalia-common';
import HomeBookshelvesLeaderboard from '../components/HomeBookshelvesLeaderboard';

export default function (): void {
	extend(components.HomePage.prototype, 'leaderboardBlocks', function (blocks) {
		blocks.add('bookshelves-leaderboard', <HomeBookshelvesLeaderboard />, 2);
	});
}
